export function formatShort(n: number): string {
  if (Math.abs(n) >= 1_000_000) return '$' + (n / 1_000_000).toFixed(1) + 'M';
  if (Math.abs(n) >= 1_000) return '$' + (n / 1_000).toFixed(1) + 'K';
  return '$' + n.toFixed(0);
}

export function formatMoney(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function colorBarra(positivo: boolean, rayado: boolean): string {
  if (rayado) return positivo ? 'url(#hatchGreen)' : 'url(#hatchRed)';
  return positivo ? '#22c55e' : '#f87171';
}

export const customizeTooltip = (arg: any): { text: string } => ({
  text: arg.seriesName === 'Kg'
    ? `Kg: ${(arg.value ?? 0).toLocaleString('es-AR', { maximumFractionDigits: 0 })} Kg`
    : `Pesos: ${formatShort(arg.value ?? 0)}`
});
